import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Location } from '@angular/common';
declare var iziToast: any;
import Swal from 'sweetalert2';

@Component({
  selector: 'app-renewal-payment',
  templateUrl: './renewal-payment.component.html',
  styleUrls: ['./renewal-payment.component.css']
})
export class RenewalPaymentComponent implements OnInit {

  renewalForm: FormGroup;
  nextdate: any;
  plan_price: any;
  base_price: any;
  discout_price: any;
  disc_price_2_txt: any;
  tax_price: any;
  total_price: any;
  pre_tax_price: any;
  post_code: any;
  user_id: any;
  api_version: any;
  client_id: any;
  nas_id: any;
  ps_key: any;
  constructor(private fb: FormBuilder, public location: Location) {

    this.renewalForm = this.fb.group({
      first_name: [''],
      last_name: [''],
      plan_name: [''],
      phone_number: [''],
      account_state: [''],
      currnet_plan_type: [''],
      payment_type: ['']
    });

  }

  ngOnInit(): void {
    this.user_id = localStorage.getItem('user_name');
    this.api_version = localStorage.getItem('api_version');
    this.client_id = localStorage.getItem('client_id');
    this.nas_id = localStorage.getItem('nas_id');
    this.ps_key = localStorage.getItem('ps_key');
    this.getUaerPlanDetails();
  }

  cancel() {

    this.location.back();
  }


  getUaerPlanDetails() {
    var data: any = new FormData();
    // data.append("api_version", this.api_version);
    // data.append("client_id", this.client_id);
    // data.append("ps_key", this.ps_key);
    // data.append("nas_id", this.nas_id);
    data.append("action_id", "get_user_id_plan_details");
    data.append("action", "get_url");
    data.append("req_params", JSON.stringify({ user_id: this.user_id }));

    var self = this;
    $.ajax({
      type: "POST",

      url: "https://chettinadlink.com/zoho-apis/",
      cache: false,
      contentType: false,
      processData: false,
      data: data,

      success: function (result: any) {



        if (result.message == "success") {


          if (result.results) {


            const userPlan = result.results;
            self.renewalForm.patchValue({
              first_name: userPlan.f_name,
              last_name: userPlan.l_name,
              plan_name: userPlan.plan_name,
              phone_number: userPlan.mobile,
              account_state: userPlan.account_state,
              currnet_plan_type: userPlan.currnet_plan_type,
              payment_type: userPlan.payment_type
            });

            self.nextdate = userPlan.num_days_txt;

            self.base_price = userPlan.base_price;
            self.discout_price = userPlan.discount_price;
            self.disc_price_2_txt = userPlan.disc_price_2_txt;
            self.pre_tax_price = userPlan.pre_tax_price;
            self.tax_price = userPlan.tax_price;
            self.plan_price = userPlan.plan_price;
            self.total_price = userPlan.total_price;
            self.post_code = userPlan.post_code;
          } else {
            console.error("No plan details found for the user.");

          }
        }
      }
    });

  }


  paymentSubmit() {

    if (this.renewalForm.get('account_state')?.value !== 'expired') {
      console.warn('Cannot submit — Account state is not expired.');
      return;
    }


    Swal.fire({
      title: 'Are you sure to Renewal Payment?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Renewal it!'
    });


    // return false;

    var data: any = new FormData();
    // data.append("api_version", this.api_version);
    // data.append("client_id", this.client_id);
    // data.append("ps_key", this.ps_key);
    // data.append("nas_id", this.nas_id);
    data.append("action_id", "post_ve_payment_to_user_id");
    data.append("action", "get_url");
    data.append("req_params", JSON.stringify({ "user_id": this.user_id, "total_amount": this.total_price, "renew_type": "normal", "post_code": this.post_code, "discount_coupon_code": "", "order_id": "1234" }));

    var self = this;
    $.ajax({
      type: "POST",

      url: "https://chettinadlink.com/zoho-apis/",
      cache: false,
      contentType: false,
      processData: false,
      data: data,

      success: function (result: any) {



        if (result.success == true || result.success == "true") {
          // Handle success response
          console.log("Payment successful:", result.message);
          iziToast.success({
            message: result.message,
            position: 'topRight'
          });
          window.location.reload();
        }
        else {
          // Handle error response
          iziToast.error({
            message: result.message,
            position: 'topRight'
          });
        }
      }
    });



  }







}













